import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import { useAuth } from '../context/AuthContext';
import { useWallet } from '../context/WalletContext';
import SunIllustration from '../components/SunIllustration';
import HeaderBar from '../components/HeaderBar';
import TaskCard from '../components/TaskCard';

const INITIAL_TASKS = [
  { id: '1', name: 'Take daily methadone', done: false, type: 'medication' },
  { id: '2', name: 'Take daily naltrexone', done: false, type: 'medication' },
  { id: '3', name: 'Drink water', done: false, type: 'selfCare' },
  { id: '4', name: 'Brush teeth', done: false, type: 'selfCare' },
  { id: '5', name: 'Go for a walk', done: false, type: 'wellness' },
  { id: '6', name: 'Connect with a friend', done: false, type: 'wellness' },
];

export default function HomeScreen({ navigation }) {
  const { user } = useAuth();
  const { rewards } = useWallet();
  const [tasks, setTasks] = useState(INITIAL_TASKS);

  function toggleTask(id) {
    setTasks(function(prev) {
      return prev.map(function(t) {
        return t.id === id ? Object.assign({}, t, { done: !t.done }) : t;
      });
    });
  }

  var name = user ? user.name : 'Jackie Crowley';
  var streak = user ? user.streak : 1;

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.safe} edges={['top']}>
        <ScrollView style={styles.scroll} contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
          {/* Header */}
          <HeaderBar
            navigation={navigation}
            walletCount={rewards.length}
          />

          {/* Greeting */}
          <View style={styles.greetingRow}>
            <View style={styles.greetingText}>
              <Text style={styles.date}>Fri, Jan.24th</Text>
              <Text style={styles.greeting}>Good morning!</Text>
              <Text style={styles.name}>{name}</Text>
            </View>
            <SunIllustration size={65} />
          </View>

          {/* Pledge Card */}
          <View style={styles.pledgeCard}>
            <Text style={styles.pledgeEmoji}>❤️</Text>
            <View style={styles.pledgeContent}>
              <Text style={styles.pledgeLabel}>Pledge</Text>
              <Text style={styles.pledgeText}>
                "I'm getting better to be a part of my daughter's life again."
              </Text>
            </View>
          </View>

          {/* Streak & Milestone */}
          <View style={styles.statsRow}>
            <View style={styles.statCard}>
              <Icon name="flame" size={20} color={Colors.accent} />
              <View>
                <Text style={styles.statLabel}>Streak</Text>
                <Text style={[styles.statValue, { color: Colors.coral }]}>{streak} Days</Text>
              </View>
            </View>
            <View style={styles.statCard}>
              <Icon name="diamond" size={20} color={Colors.primary} />
              <View>
                <Text style={styles.statLabel}>Next Milestone</Text>
                <Text style={[styles.statValue, { color: Colors.primary }]}>in 13 days</Text>
              </View>
            </View>
          </View>

          {/* Today's Tasks */}
          <Text style={styles.sectionTitle}>Today's Tasks</Text>
          {tasks.map(function(task) {
            return (
              <TaskCard
                key={task.id}
                task={task}
                onToggle={function() { toggleTask(task.id); }}
              />
            );
          })}

          <View style={styles.bottomSpacer} />
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  scroll: { flex: 1 },
  scrollContent: { paddingBottom: 100 },
  greetingRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', paddingHorizontal: 20, marginTop: 4 },
  greetingText: { flex: 1 },
  date: { fontSize: 13, color: Colors.textMid },
  greeting: { fontSize: 14, color: Colors.textMid, marginTop: 2 },
  name: { fontSize: 28, fontWeight: '700', color: Colors.textDark },
  pledgeCard: {
    marginHorizontal: 20,
    marginTop: 14,
    padding: 16,
    borderRadius: 16,
    backgroundColor: '#EDE5D8',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
  },
  pledgeEmoji: { fontSize: 20 },
  pledgeContent: { flex: 1 },
  pledgeLabel: { fontSize: 12, color: Colors.textMid, fontWeight: '600' },
  pledgeText: { fontSize: 14, color: Colors.textDark, fontStyle: 'italic', lineHeight: 20, marginTop: 4 },
  statsRow: { flexDirection: 'row', gap: 10, paddingHorizontal: 20, marginTop: 14, marginBottom: 18 },
  statCard: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: Colors.card,
    borderRadius: 14,
    padding: 12,
  },
  statLabel: { fontSize: 10, color: Colors.textMid },
  statValue: { fontSize: 16, fontWeight: '700' },
  sectionTitle: { fontSize: 17, fontWeight: '700', color: Colors.textDark, paddingHorizontal: 20, marginBottom: 12 },
  bottomSpacer: { height: 20 },
});
